export const kimchiPremiumRoutePaths = {
  kimchiPremium: {
    path: '/kimchi-premium',
    name: '김치프리미엄',
  },
  // TRAD-3709 P2 — 일간 페이지(YYYY-MM-DD 검증은 페이지가 한다 — 틀린 값은 NotFound). 캘린더 일자 라우트와 같은 모양.
  kimchiPremiumDay: {
    path: '/kimchi-premium/:date',
  },
} as const;
